import React from "react";
import FieldConfig from "../../proto/field-config";
import FieldProto from "../../proto/field-proto";
import FieldMeeting_View from "./render/view";
import Task from "../../../model2/task/task";

export default class FieldMeeting extends FieldProto {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Meeting";

        this.renderComponents.view          = FieldMeeting_View
        this.renderComponents.viewSmall     = FieldMeeting_View
        this.renderComponents.viewReference = FieldMeeting_View
        this.renderComponents.glistView     = FieldMeeting_View
    }


    // normalize value for sorting
    sortValue(value:Task, model?:any) {
        return value ? value.title.toLowerCase() : ''
    }
}